import { mobile, desktopHeight, desktop } from '@/utils/helpers/breakpoint';

const state = {
  width: 0,
  height: 0,
  isMobile: false,
  isDesktop: false,
  isMobileWithHeight: false,
};

const getters = {
  width: state => state.width,
  height: state => state.height,
  isMobile: state => state.isMobile,
  isDesktop: state => state.isDesktop,
  isMobileWithHeight: state => state.isMobileWithHeight,
};

const mutations = {
  SET_DIMENSION(state, { width, height }) {
    state.height = height;
    state.width = width;
    state.isMobile = width <= mobile || height < desktopHeight;
    state.isDesktop = width >= desktop && height >= desktopHeight;
    state.isMobileWithHeight = width >= mobile && height >= desktopHeight;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
